module.exports = __webpack_public_path__ + "img/FIB.b84982cd.png";